/* Reseñas en carrusel: arrastre con ratón que engancha a la tarjeta más cercana (el táctil usa el
   scroll nativo con scroll-snap), flechas y teclado. Comportamiento medido en la referencia:
   300 ms easeOutCubic, cambia de tarjeta si se arrastra > 50 % o > 20 px en < 300 ms, 8 px = clic. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(root) {
    if (root.dataset.init) return;
    root.dataset.init = '1';
    // «Ver todas las reseñas» (11-oct): baja suave hasta la lista completa de Revie. La lista se
    // busca EN EL CLIC (Revie puede hidratar su contenedor después de este script); si no está,
    // o el clic viene modificado (cmd/ctrl/shift), se deja el ancla nativa #cont-rl-w como respaldo.
    var verTodas = root.querySelector('[data-prc-ver-todas]');
    if (verTodas) {
      verTodas.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        var listaRevie = document.querySelector('#cont-rl-w, [data-rvw2], #revieList');
        if (!listaRevie) return;
        e.preventDefault();
        listaRevie.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      });
    }
    var track = root.querySelector('[data-prc-track]');
    var cards = track ? [].slice.call(track.children) : [];
    if (!cards.length) return;
    var prev = root.querySelector('[data-prc-prev]');
    var next = root.querySelector('[data-prc-next]');
    var anim = null;

    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function nearest() {
      var best = 0, bd = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - track.scrollLeft);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    function arrows() {
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll() - 1;
    }
    function animateTo(target) {
      if (anim) cancelAnimationFrame(anim);
      target = Math.max(0, Math.min(target, maxScroll()));
      var start = track.scrollLeft, dist = target - start, t0 = null;
      track.classList.add('is-moving');
      if (reduce.matches || Math.abs(dist) < 1) {
        track.scrollLeft = target;
        track.classList.remove('is-moving');
        return;
      }
      anim = requestAnimationFrame(function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / 300, 1);
        track.scrollLeft = start + dist * (1 - Math.pow(1 - p, 3));
        if (p < 1) anim = requestAnimationFrame(frame);
        else { anim = null; track.classList.remove('is-moving'); }
      });
    }
    function goTo(i) { animateTo(cards[Math.max(0, Math.min(i, cards.length - 1))].offsetLeft); }

    if (prev) prev.addEventListener('click', function () { goTo(nearest() - 1); });
    if (next) next.addEventListener('click', function () { goTo(nearest() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(nearest() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(nearest() - 1); }
    });
    track.addEventListener('scroll', arrows, { passive: true });
    /* Revisión 9-oct: la rueda del ratón manda sobre una animación en curso, y un cambio de
       tamaño de la ventana recalcula el estado de las flechas (antes quedaban obsoletas). */
    track.addEventListener('wheel', function () {
      if (anim) { cancelAnimationFrame(anim); anim = null; track.classList.remove('is-moving'); }
    }, { passive: true });
    window.addEventListener('resize', arrows);
    arrows();

    var down = false, dragged = false, sx = 0, sl = 0, startIdx = 0, t0 = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (anim) { cancelAnimationFrame(anim); anim = null; track.classList.remove('is-moving'); }
      down = true; dragged = false; sx = e.clientX; sl = track.scrollLeft; startIdx = nearest(); t0 = e.timeStamp;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      /* Revisión 9-oct: si el botón ya no está pulsado (se soltó fuera), no hay arrastre fantasma. */
      if (e.buttons === 0) {
        down = false; dragged = false;
        track.classList.remove('is-dragging', 'is-moving');
        return;
      }
      var dx = e.clientX - sx;
      if (!dragged && Math.abs(dx) > 8) {
        dragged = true;
        track.classList.add('is-dragging', 'is-moving');
        try { track.setPointerCapture(e.pointerId); } catch (_) {}
      }
      if (dragged) track.scrollLeft = Math.max(0, Math.min(sl - dx, maxScroll()));
    });
    function release(e) {
      if (!down) return;
      down = false;
      if (!dragged) return;
      track.classList.remove('is-dragging');
      /* Revisión 9-oct: el golpe corto pasa a la tarjeta siguiente; el arrastre largo engancha a la
         más cercana al punto donde se soltó (antes rebotaba a startIdx±1 deshaciendo el recorrido). */
      var dx = e.clientX - sx, w = cards[startIdx].getBoundingClientRect().width || 1, target;
      if (e.timeStamp - t0 < 300 && Math.abs(dx) > 20) target = startIdx + (dx < 0 ? 1 : -1);
      else if (Math.abs(dx) > w * 0.5) target = nearest();
      else target = startIdx;
      goTo(target);
      var kill = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
      track.addEventListener('click', kill, true);
      setTimeout(function () { track.removeEventListener('click', kill, true); }, 50);
    }
    /* Revisión 9-oct: en window, para que soltar fuera del carrusel también termine el arrastre. */
    window.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', function () {
      down = false; dragged = false;
      track.classList.remove('is-dragging', 'is-moving');
    });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function init() { [].slice.call(document.querySelectorAll('[data-prc]')).forEach(setup); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
